import React from 'react'
import { SVGProps } from 'react'

const QueryStructuredData = (
  props: SVGProps<SVGSVGElement>,
): React.ReactNode => (
  <svg
    {...props}
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="24.707"
      y="23.3321"
      width="7.78143"
      height="1.64142"
      transform="rotate(45 24.707 23.3321)"
      stroke="#62AC62"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.9489 39.6283L39.6116 45.0057L27.1416 32.446L29.7623 29.808L32.4806 27.0703L44.9489 39.6283Z"
      fill="#62AC62"
      fillOpacity="0.3"
      stroke="#62AC62"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.00042 14.3167C1.00042 17.8736 2.38623 21.2178 4.90089 23.7344H4.90266C5.89151 24.7233 7.0239 25.5474 8.26616 26.1819C10.1499 27.146 12.1859 27.6334 14.3178 27.6334C19.3455 27.6334 23.8928 24.8509 26.1824 20.3689C26.6643 19.4261 27.0275 18.4478 27.2705 17.4358C27.5115 16.4239 27.6338 15.3818 27.6338 14.3167C27.6338 13.0867 27.4654 11.8657 27.1303 10.6836C26.6166 8.86879 25.741 7.21528 24.5255 5.76558C21.986 2.7368 18.2645 1 14.3178 1C12.1879 1 10.1517 1.48914 8.26616 2.45324C4.24874 4.50728 1.56219 8.40091 1.07999 12.867V12.8705C1.02683 13.3526 1.00042 13.8399 1.00042 14.3167Z"
      stroke="#62AC62"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.5635 14.2852C25.5635 17.2973 24.3899 20.1294 22.2603 22.2606H22.2588C21.4214 23.0981 20.4624 23.796 19.4104 24.3333C17.8151 25.1498 16.0909 25.5625 14.2855 25.5625C10.0278 25.5625 6.17686 23.2062 4.2379 19.4105C3.82985 18.6121 3.52219 17.7836 3.31644 16.9266C3.11234 16.0697 3.00879 15.1872 3.00879 14.2852C3.00879 13.2436 3.15136 12.2095 3.43515 11.2084C3.87022 9.67156 4.61173 8.27127 5.64109 7.04358C7.79166 4.47864 10.9432 3.00781 14.2855 3.00781C16.0893 3.00781 17.8136 3.42205 19.4104 4.2385C22.8126 5.97798 25.0877 9.27534 25.4961 13.0575V13.0605C25.5411 13.4687 25.5635 13.8814 25.5635 14.2852"
      fill="white"
      fillOpacity="0.5"
    />
    <path
      d="M25.5635 14.2852C25.5635 17.2973 24.3899 20.1294 22.2603 22.2606H22.2588C21.4214 23.0981 20.4624 23.796 19.4104 24.3333C17.8151 25.1498 16.0909 25.5625 14.2855 25.5625C10.0278 25.5625 6.17686 23.2062 4.2379 19.4105C3.82985 18.6121 3.52219 17.7836 3.31644 16.9266C3.11234 16.0697 3.00879 15.1872 3.00879 14.2852C3.00879 13.2436 3.15136 12.2095 3.43515 11.2084C3.87022 9.67156 4.61173 8.27127 5.64109 7.04358C7.79166 4.47864 10.9432 3.00781 14.2855 3.00781C16.0893 3.00781 17.8136 3.42205 19.4104 4.2385C22.8126 5.97798 25.0877 9.27534 25.4961 13.0575V13.0605C25.5411 13.4687 25.5635 13.8814 25.5635 14.2852"
      stroke="#62AC62"
    />
  </svg>
)

export default QueryStructuredData
